<template>
  <div>
    <p>{{ msg.num }}</p>
    <button @click="change">BBBBB</button>
    <div id="counter">Counter: {{ counter }}</div>
  </div>
</template>

<script>
import { reactive } from "vue";
export default {
  setup() {
    let msg = reactive({
      num: 0,
    });
    function change() {
      msg.num++;
    }
    return {
      msg,
      change,
    };
  },
  data() {
    return {
      counter: 0,
    };
  },
  mounted() {
    setInterval(() => {
      this.counter++;
    }, 1000);
  },
};
</script>
